import DesignLibraryModalManager from "components/jiffy/design-library-modal/design-library-modal";

document.addEventListener("DOMContentLoaded", () => new DesignLibraryModalManager());
